
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonApiService {
  constructor(private http: HttpClient) {}

  Get<T>(controller: string): Observable<T> {
    return this.http.get<T>(`${controller}`);
  }

  GetList<T>(controller: string): Observable<T> {
    return this.http.get<T>(`${controller}`);
  }

  Post(controller: string, data: any): Observable<any> {
    return this.http.post<any>(`${controller}`, data);
  }

  Search<T>(controller: string, data: any): Observable<T> {
    return this.http.post<T>(`${controller}`, data);
  }

  Put(controller: string, data: any): Observable<any> {
    return this.http.put<any>(`${controller}`, data);
  }

  Delete(controller: string) {
    return this.http.delete<any>(`${controller}`, {});
  }
}
